import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
/**
 * 报警图层
 */
class AlarmLayer extends BaseLayer{

    constructor(options={}){
        options.layerName=options.layerName||CONSTANTS.LAYER.ALARM;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.forEach((obj,index) =>{
            let item={...obj};
            item.layerName=self.layerName;
            if(item.longitude && item.latitude){
                let entity=new Cesium.Entity({
                    position: Cesium.Cartesian3.fromDegrees(item.longitude,item.latitude, CONSTANTS.ALTITUDE),
                    id:item.id,
                    attributes:item,
                    //立广告牌
                    billboard :{
                        image : "/static/imgs/map/alarm.png",
                        show : true,
                        width : 340,
                        height : 80,
                        pixelOffset:new Cesium.Cartesian2(0, 0)
                    },
                    label:{
                        text : "报警: '罐区风险12'顾狄轲(1时)过期未排查 \n " +
                               "报警时间：2022-08-09 23:00:20",
                        style:Cesium.LabelStyle.FILL_AND_OUTLINE,
                        fillColor:Cesium.Color.fromCssColorString('#FCF516'),
                        outlineColor:Cesium.Color.fromCssColorString('#2D3635'),
                        outlineWidth:4,
                        font: "14px Helvetica",
                        showBackground : false,
                        pixelOffset:new Cesium.Cartesian2(-6, -10)
                    }
                })
                self.dataSource.entities.add(entity);
            }
        });
    }
}
export default AlarmLayer;
